/**
 * auto-discount-prices.js v13
 * Soporta tema Dawn (price.liquid) Y template personalizado (dnature-product__price)
 * Badge color: #455FBB
 *
 * v13: cada producto se evalúa en su propio carrito aislado (una petición
 * cartCreate por producto) en lugar de meter todas las líneas en un solo
 * carrito. Esto evita que las reglas de "Combine with" de Shopify entre
 * descuentos automáticos excluyan el descuento de algunos productos cuando
 * compiten con otros en el mismo carrito.
 */

(function () {

  var STOREFRONT_TOKEN = '7784eb641bc071f231dda3e603a9fa6e';
  var SHOP_DOMAIN      = window.location.hostname;
  var API_URL          = 'https://' + SHOP_DOMAIN + '/api/2024-10/graphql.json';
  var BADGE_COLOR      = '#455FBB';
  var BADGE_TEXT       = 'Sale';

  var useCurrency = /[A-Z]{3}/.test(
    (document.querySelector('.price-item, .dnature-product__price') || {}).textContent || ''
  );

  function formatPrice(amount) {
    var val = parseFloat(amount).toFixed(2);
    if (useCurrency) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      return '$' + val + ' ' + currency;
    }
    var fmt = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
    return fmt.replace('{{amount}}', val)
              .replace('{{amount_no_decimals}}', String(Math.round(amount)));
  }

  // ─── UN CARRITO AISLADO POR PRODUCTO ────────────────────────────────────────
  function getDiscountedPrices(targets) {
    if (!targets.length) return Promise.resolve({});

    var mutation = `
      mutation cartCreate($lines: [CartLineInput!]!) {
        cartCreate(input: { lines: $lines }) {
          cart {
            id
            lines(first: 1) {
              edges {
                node {
                  merchandise {
                    ... on ProductVariant {
                      product { handle }
                    }
                  }
                  cost { totalAmount { amount } }
                  discountAllocations {
                    discountedAmount { amount }
                  }
                }
              }
            }
          }
          userErrors { message }
        }
      }
    `;

    // Una petición cartCreate INDEPENDIENTE por cada target, así ningún
    // descuento automático compite con otro por las reglas de "Combine with".
    var promises = targets.map(function (t) {
      return fetch(API_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN
        },
        body: JSON.stringify({
          query: mutation,
          variables: { lines: [{ quantity: 1, merchandiseId: t.gid }] }
        })
      })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.errors) {
          console.warn('[AutoDiscount]', t.handle, JSON.stringify(data.errors));
          return null;
        }

        var cart = data && data.data && data.data.cartCreate && data.data.cartCreate.cart;
        if (!cart) { console.warn('[AutoDiscount] cart null for', t.handle); return null; }

        var edge = cart.lines && cart.lines.edges && cart.lines.edges[0];
        var result = null;

        if (edge) {
          var node   = edge.node;
          var handle = node.merchandise && node.merchandise.product && node.merchandise.product.handle;
          var final  = node.cost && parseFloat(node.cost.totalAmount.amount);
          var allocs = node.discountAllocations || [];

          if (handle && allocs.length > 0) {
            var totalDiscount = 0;
            allocs.forEach(function (d) { totalDiscount += parseFloat(d.discountedAmount.amount); });
            result = { handle: handle, finalPrice: final, originalPrice: final + totalDiscount };
          }
        }

        // Borra el carrito temporal (no necesitamos esperar la respuesta)
        fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': STOREFRONT_TOKEN },
          body: JSON.stringify({ query: 'mutation($id:ID!){cartDelete(id:$id){deletedId}}', variables: { id: cart.id } })
        });

        return result;
      })
      .catch(function (err) {
        console.warn('[AutoDiscount] fetch error for', t.handle, err);
        return null;
      });
    });

    return Promise.all(promises).then(function (results) {
      var priceMap = {};
      results.forEach(function (r) {
        if (r) priceMap[r.handle] = { finalPrice: r.finalPrice, originalPrice: r.originalPrice };
      });
      return priceMap;
    });
  }

  // ─── APLICA A TARJETA DE COLECCIÓN (Dawn) ───────────────────────────────────
  function applyToCard(card, originalPrice, finalPrice) {
    if (!finalPrice || finalPrice >= originalPrice) return;

    var priceEl = card.querySelector('.price');
    if (!priceEl) return;

    priceEl.classList.add('price--on-sale');
    var regularDiv = priceEl.querySelector('.price__regular');
    if (regularDiv) regularDiv.style.display = 'none';

    var saleDiv = priceEl.querySelector('.price__sale');
    if (saleDiv) {
      saleDiv.style.display = '';
      var strikeEl = saleDiv.querySelector('s.price-item--regular');
      if (strikeEl) {
        strikeEl.textContent = formatPrice(originalPrice);
      } else {
        var s = document.createElement('span');
        s.innerHTML = '<s class="price-item price-item--regular">' + formatPrice(originalPrice) + '</s>';
        saleDiv.insertBefore(s, saleDiv.firstChild);
      }
      var salePriceEl = saleDiv.querySelector('.price-item--sale');
      if (salePriceEl) salePriceEl.textContent = formatPrice(finalPrice);
    }

    var badgeContainer = card.querySelector('.card__badge');
    if (badgeContainer && !badgeContainer.querySelector('.auto-discount-badge') && !badgeContainer.querySelector('[id*="Badge"]')) {
      var badge = document.createElement('span');
      badge.className = 'badge badge--bottom-left auto-discount-badge';
      badge.style.cssText = 'background-color:' + BADGE_COLOR + ';color:#fff;';
      badge.textContent = BADGE_TEXT;
      badgeContainer.appendChild(badge);
    }
  }

  // ─── APLICA A PÁGINA DE PRODUCTO (Dawn price.liquid) ────────────────────────
  function applyToDawnProduct(section, originalPrice, finalPrice) {
    if (!finalPrice || finalPrice >= originalPrice) return;

    var priceEl = document.querySelector('.price--large') || section.querySelector('.price');
    if (!priceEl) return;

    priceEl.classList.add('price--on-sale', 'price--show-badge');
    var regularDiv = priceEl.querySelector('.price__regular');
    if (regularDiv) regularDiv.style.display = 'none';

    var saleDiv = priceEl.querySelector('.price__sale');
    if (saleDiv) {
      saleDiv.style.display = '';
      var strikeEl = saleDiv.querySelector('s.price-item--regular');
      if (strikeEl) {
        strikeEl.textContent = formatPrice(originalPrice);
      } else {
        var s = document.createElement('span');
        s.innerHTML = '<s class="price-item price-item--regular">' + formatPrice(originalPrice) + '</s>';
        saleDiv.insertBefore(s, saleDiv.firstChild);
      }
      var salePriceEl = saleDiv.querySelector('.price-item--sale');
      if (salePriceEl) salePriceEl.textContent = formatPrice(finalPrice);
    }

    var badgeSale = priceEl.querySelector('.price__badge-sale');
    if (badgeSale) {
      badgeSale.style.cssText = 'background-color:' + BADGE_COLOR + ';color:#fff;display:inline-block;';
    } else {
      var newBadge = document.createElement('span');
      newBadge.className = 'badge price__badge-sale auto-discount-badge';
      newBadge.style.cssText = 'background-color:' + BADGE_COLOR + ';color:#fff;';
      newBadge.textContent = BADGE_TEXT;
      priceEl.appendChild(newBadge);
    }
  }

  // ─── APLICA A TEMPLATE PERSONALIZADO (dnature-product__price) ───────────────
  function applyToDnatureProduct(originalPrice, finalPrice) {
    if (!finalPrice || finalPrice >= originalPrice) return;

    var priceEl = document.querySelector('.dnature-product__price');
    if (!priceEl) return;

    // Muestra precio con descuento + tachado
    priceEl.innerHTML =
      '<span style="color:inherit;">' + formatPrice(finalPrice) + '</span>' +
      '<s style="color:#999;font-size:0.8em;margin-left:8px;">' + formatPrice(originalPrice) + '</s>';

    // Badge Sale
    var priceContainer = document.querySelector('.dnature-product__price');
    if (priceContainer && !document.querySelector('.dnature-auto-discount-badge')) {
      var badge = document.createElement('span');
      badge.className = 'dnature-auto-discount-badge';
      badge.style.cssText = 'display:inline-block;background:' + BADGE_COLOR + ';color:#fff;padding:4px 12px;border-radius:100px;font-size:12px;font-weight:600;margin-left:8px;font-family:Montserrat,sans-serif;vertical-align:middle;';
      badge.textContent = BADGE_TEXT;
      priceContainer.appendChild(badge);
    }
  }

  // ─── PROCESO PRINCIPAL ───────────────────────────────────────────────────────
  function processAll() {
    var cards   = Array.from(document.querySelectorAll('[data-auto-discount-card]'));
    var section = document.querySelector('[data-auto-discount-product]');
    var targets = [];

    cards.forEach(function (card) {
      var gid    = card.dataset.variantGid;
      var handle = card.dataset.productHandle;
      if (gid && handle) targets.push({ gid: gid, handle: handle, element: card, type: 'card' });
    });

    if (section) {
      var gid    = section.dataset.variantGid;
      var handle = section.dataset.productHandle;
      if (gid && handle) targets.push({ gid: gid, handle: handle, element: section, type: 'product' });
    }

    if (!targets.length) return;

    getDiscountedPrices(targets).then(function (priceMap) {
      targets.forEach(function (t) {
        var prices = priceMap[t.handle];
        if (!prices) return;

        if (t.type === 'card') {
          applyToCard(t.element, prices.originalPrice, prices.finalPrice);
        } else {
          // Detecta qué template está usando
          if (document.querySelector('.dnature-product__price')) {
            applyToDnatureProduct(prices.originalPrice, prices.finalPrice);
          } else {
            applyToDawnProduct(t.element, prices.originalPrice, prices.finalPrice);
          }
        }
      });
    }).catch(function (err) {
      console.warn('[AutoDiscount]', err);
    });
  }

  // ─── CAMBIO DE VARIANTE ──────────────────────────────────────────────────────
  document.addEventListener('variant:changed', function (e) {
    var variant = e.detail && e.detail.variant;
    if (!variant) return;

    var section = document.querySelector('[data-auto-discount-product]');
    if (!section) return;

    // Limpia badge anterior
    var oldBadge = document.querySelector('.dnature-auto-discount-badge, .auto-discount-badge');
    if (oldBadge) oldBadge.remove();

    var gid = 'gid://shopify/ProductVariant/' + variant.id;
    section.dataset.variantGid = gid;

    getDiscountedPrices([{ gid: gid, handle: section.dataset.productHandle }])
      .then(function (priceMap) {
        var prices = priceMap[section.dataset.productHandle];
        if (!prices) return;
        if (document.querySelector('.dnature-product__price')) {
          applyToDnatureProduct(prices.originalPrice, prices.finalPrice);
        } else {
          applyToDawnProduct(section, prices.originalPrice, prices.finalPrice);
        }
      });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', processAll);
  } else {
    processAll();
  }

})();